import Page from "src/components/Page";
import StageTaskManagement from "./StageTaskManagement";

export default function Tasks() {
    return (
        <Page title="Task Backlog" sx={{ height: '100%' }}>
            <StageTaskManagement />
        </Page>
    );
}